// extracted by mini-css-extract-plugin
export var compactFilters = "_hb-4";
export var detailImage = "_hb-1";
export var dropdownContainer = "_hb-2";
export var imageContainer = "_hb-0";
export var selectedCard = "_hb-3";